import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../Apis/Authentication';
import Dropdown from 'react-bootstrap/Dropdown';
import { useDispatch, useSelector } from 'react-redux';
import LanguageSelector from './LanguageSelector';
import uaeFlag from '../assets/images/uaeFlag.png';
import franceFlag from '../assets/images/france.png';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import { userTypeDrop } from '../enums/userTypeEnumDrop';
import { GetUserFullInformation } from '../reduxToolkit/Commons/CommonsApi';
import {IconExitDevice, IconProfile, IconProfileDropDown} from './buttons/IconButtons';

const SidebarDropDownOption = ({ isMenuOpen, menutop }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.authenticatioauthennSlice);

    const notificationCount = useSelector((state) => state.ReportSlice.notificationCount);
    const { idSet } = useSelector((state) => state.CommonsSlice);
    const [selfie, setSelfie]  = useState(null);
    const userId = idSet || sessionStorage.getItem('id');

    const languages = [
        {
            id: 2,
            name: 'spanish',
            code: 'sp',
            flag: uaeFlag
        },
        {
            id: 1,
            name: 'english',
            code: 'en',
            flag: uaeFlag
        },
        {
            id: 3,
            name: 'french',
            code: 'fr',
            flag: franceFlag
        }
    ];

    const currentLanguageCode = Cookies.get('i18next') || 'en';
    const [currentLanguage, setCurrentLanguage] = useState({});
    const { t } = useTranslation();

    useEffect(() => {
        setCurrentLanguage(languages.find((l) => l.code === currentLanguageCode));
        document.body.dir = currentLanguage?.dir || 'ltr';
        document.body.style.textAlign = currentLanguageCode === 'ar' ? 'right' : 'left';
        document.title = t('app_title');
    }, [idSet, currentLanguageCode, t, dispatch]);

    useEffect(() => {
        if(userId){
            dispatch(GetUserFullInformation(userId)).then(({payload: {data: { data}}}) => {
                    setSelfie(data?.selfie);
            });
        }
    }, [userId]);

    return (
        <>
            <Dropdown drop='end' className='login_option_header'>
                <Dropdown.Toggle variant='success' id='dropdown-basic' className={'profile_option_menutop btnProfile'}>
                    <Tooltip title={!isMenuOpen ? user?.data?.name : ''} placement='right'>
                        <div id='btn_sddp_profile' className={`${isMenuOpen ? 'pl-2' : ''}`}>
                            {selfie ? (
                                <img src={`data:image/png;base64,${selfie}`} alt='profile' className='profile-img' />
                            ) : (
                                <IconProfile className={`sideLogoL ${isMenuOpen ? '' : 'hiddenLogo'}`} />
                            )}
                            {notificationCount > 0 && <div className='notification-badge-img'>{notificationCount}</div>}
                        </div>
                    </Tooltip>

                    <span className='dropSpan fs-20px ibl-font-w-600 text-ellipsis'>
                        {(isMenuOpen || menutop) && user?.data?.name}
                    </span>
                </Dropdown.Toggle>
                <Dropdown.Menu drop='end' className={`sidebar_option_container_side ${isMenuOpen ? 'leftMenu' : 'leftMenuClose'} ${menutop ? 'leftMenuTop' : ''}`}>
                    <div className='sidebar_option_container_header'>
                        <IconProfileDropDown />
                        <div>
                            <Tooltip title={user?.data?.name} placement='right'>
                                <p className={'font-color-text-950 ibl-h5 ibl-font-w-300 text-ellipsis-card-chip'}>
                                    {user?.data?.name}
                                </p>
                            </Tooltip>

                            <p className={'fs-14px font-color-general-950 ibl-font-w-600 ibl-font-w-600 '}>
                                {t(userTypeDrop[user?.data?.userType?.id])}
                            </p>
                        </div>
                    </div>
                    <div id='btn_sddp_language' className='sidebar_option_body_item'>
                        <LanguageSelector isMenuOpen={isMenuOpen} menutop={menutop} />
                    </div>
                    <div id='btn_sddp_notifications' className='sidebar_option_body_item'>
                        <div
                            className='d-flex align-items-center justify-content-between w-100'
                            onClick={() => logoutUser(navigate, dispatch)}
                        >
                            <p className='fs-14px font-color-general-950 ibl-font-w-400'>{t('log_out')}</p>
                            <IconExitDevice className='w-21px h-21px pr-1' />
                        </div>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
};

export default SidebarDropDownOption;
